import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);

const UserPesoVerForm = ({ user, getPesoByUser_Id, deletePesoBy_Id }) => {
  const [pesosList, setPesosList] = useState([]);
  const [pesoStats, setPesoStats] = useState({
    pesoActual: null,
    pesoMinimo: null,
    pesoMaximo: null,
  });

  useEffect(() => {
    const userId = user?.id_usuario;
  
    const fetchPesos = async () => {
      if (!userId) return;
      try {
        const pesosData = await getPesoByUser_Id(userId);
        let data = Array.isArray(pesosData.data) ? pesosData.data : [];
  
        // Ordenar los datos por fecha (ascendente)
        data = data.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
  
        setPesosList(data);
        calculatePesoStats(data); // Recalcular estadísticas con los datos ordenados
      } catch (error) {
        console.error("Error fetching pesos:", error);
        setPesosList([]);
      }
    };
  
    fetchPesos();
  }, [user, getPesoByUser_Id]);

  const calculatePesoStats = (data) => {
    if (data.length === 0) {
      setPesoStats({ pesoActual: null, pesoMinimo: null, pesoMaximo: null });
      return;
    }
    const pesos = data.map((p) => p.peso);
    setPesoStats({
      pesoActual: pesos[pesos.length - 1],
      pesoMinimo: Math.min(...pesos),
      pesoMaximo: Math.max(...pesos),
    });
  };

  const handleDelete = async (pesoId) => {
    try {
      await deletePesoBy_Id(pesoId);
      const updatedList = pesosList.filter((peso) => peso.id_peso !== pesoId);
      setPesosList(updatedList);
      calculatePesoStats(updatedList); // Recalcular estadísticas después de eliminar
      alert("Peso eliminado con éxito.");
    } catch (error) {
      console.error("Error eliminando peso:", error);
      alert("Hubo un error al intentar eliminar el peso.");
    }
  };

  const chartData = {
    labels: pesosList.map((peso) => peso.fecha),
    datasets: [
      {
        label: "Peso (Kg)",
        data: pesosList.map((peso) => peso.peso),
        borderColor: "#f28119",
        backgroundColor: "#f28119",
        fill: true,
        tension: 0.4,
      },
    ],
  };

  // Función para formatear la fecha
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
  
    // Crear fecha como UTC
    const utcDate = new Date(dateString);
  
    // Ajustar a GMT-6 (360 minutos = 6 horas)
    const localDate = new Date(utcDate.getTime() + 24 * 60 * 60 * 1000);
  
    // Formatear la fecha a 'DD-MM-YYYY'
    return localDate.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div>
      

      {pesosList.length > 0 && (
        <>
          <h3>Estadísticas de Peso:</h3>
          <table border="1" className="table">
            <thead className="table-th">
              <tr>
                <th>Peso Actual</th>
                <th>Peso Mínimo</th>
                <th>Peso Máximo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><center>{pesoStats.pesoActual} Kg</center></td>
                <td><center>{pesoStats.pesoMinimo} Kg</center></td>
                <td><center>{pesoStats.pesoMaximo} Kg</center></td>
              </tr>
            </tbody>
          </table>

          <h3>Gráfica de Peso:</h3>
          <Line data={chartData} />
        </>
      )}
      <h3>Pesos Registrados:</h3>
      <table border="1" className="table">
        <thead className="table-th">
          <tr>
            <th>Fecha</th>
            <th>Peso (Kg)</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {pesosList.length > 0 ? (
            pesosList.map((peso, index) => (
              <tr key={index}>
                <td>{formatDate(peso.fecha)}</td>
                <td><center>{peso.peso}</center></td>
                <td><center>
                  <button onClick={() => handleDelete(peso.id_peso)} className="menu-button1">
                    Borrar
                  </button></center>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No pesos found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

UserPesoVerForm.propTypes = {
  user: PropTypes.object.isRequired,
  getPesoByUser_Id: PropTypes.func.isRequired,
  deletePesoBy_Id: PropTypes.func.isRequired,
};

export default UserPesoVerForm;
